<template>
  <div>
    <b-card>
      <b-modal id="transaction-details" hide-footer>
        <template v-slot:modal-title>اطلاعات تراکنش</template>
        <div class="d-block" v-if="trDetail != null">
          <b-form-group label="وضعیت:">
            <div class="form-control">
              {{ trDetail.is_verify == 1 ? "تایید شده" : "تایید نشده" }}
            </div>
          </b-form-group>
          <b-form-group label="مبلغ:">
            <div class="form-control">
              {{ Number(trDetail.cost).toLocaleString() }}
            </div>
          </b-form-group>
          <b-form-group label="تاریخ:">
            <div class="form-control">{{ trDetail.persian_date }}</div>
          </b-form-group>
          <b-form-group label="ساعت:">
            <div class="form-control">
              {{
                new Date(trDetail.verify_date).getHours() +
                  ":" +
                  new Date(trDetail.verify_date).getMinutes()
              }}
            </div>
          </b-form-group>
          <b-form-group label="آدرس درخواست دهنده:">
            <div class="form-control">
              <b-img
                :src="
                  'media/svg/flags/' +
                    trDetail.location.countryCode.toLowerCase() +
                    '.svg'
                "
                height="20px"
              ></b-img>
              {{ trDetail.ip }}
            </div>
          </b-form-group>
          <b-form-group label="کد رهگیری پرداخت:">
            <div class="form-control">{{ trDetail.sale_reference_id }}</div>
          </b-form-group>
          <b-form-group label="شماره کارت:">
            <div class="form-control ltr">{{ trDetail.card_holder_pan }}</div>
          </b-form-group>
        </div>
        <b-button
          class="mt-3"
          block
          @click="$bvModal.hide('transaction-details')"
          >بستن</b-button
        >
      </b-modal>

      <div class="row">
        <div class="col-md-3">
          <b-form-group label="از تاریخ:">
            <date-picker clearable v-model="DateFrom"></date-picker>
          </b-form-group>
        </div>
        <div class="col-md-3">
          <b-form-group label="تا تاریخ:">
            <date-picker clearable v-model="DateTo"></date-picker>
          </b-form-group>
        </div>
        <div class="col-md-3">
          <b-form-group label="چهار رقم آخر کارت">
            <b-form-input
              id="title-1"
              required
              v-model="CardNumber"
              placeholder="چهار رقم آخر کارت "
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-3">
          <b-form-group label="کد رهگیری پرداخت">
            <b-form-input
              id="title-1"
              required
              v-model="SaleOrderId"
              placeholder="کد رهگیری پرداخت "
            ></b-form-input>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <b-form-group label="درگاه:">
            <b-form-select v-model="api" :options="merchants"> </b-form-select>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group label="نوع تراکنش" v-slot="{ ariaDescribedby }">
            <b-form-radio-group
              id="radio-group-1"
              v-model="vmType"
              :options="vmOptions"
              :aria-describedby="ariaDescribedby"
              name="radio-options"
            ></b-form-radio-group>
          </b-form-group>
        </div>
        <div class="col-md-2">
          <b-form-group label="وضعیت:">
            <b-form-checkbox
              id="checkbox-1"
              v-model="justsuccess"
              name="checkbox-1"
              value="accepted"
              unchecked-value="not_accepted"
            >
              فقط موفق
            </b-form-checkbox>
          </b-form-group>
        </div>
        <div class="col-md-3">
          <b-button ref="filter_btn" variant="success" @click="LoadData(1)">
            جستجو </b-button
          >&nbsp;
          <b-button variant="success" @click="LoadDataExcel(1)">
            خروجی اکسل
          </b-button>
        </div>
      </div>
      <b-skeleton-table
        v-if="!dataLoaded"
        :rows="10"
        :columns="7"
        :table-props="{ bordered: true, striped: true }"
      ></b-skeleton-table>
      <div v-if="dataLoaded">
        <b-table
        responsive
          style="width: 100%"
          striped
          hover
          show-empty
          empty-text="آیتمی جهت نمایش وجود ندارد"
          :fields="fields"
          :items="datas"
        >
          <template v-slot:cell(details)="row">
            <b-button
              v-if="row.item.transaction_id != null"
              @click="ShowDetail(row.item.transaction_id)"
              variant="primary"
              size="sm"
              style="padding: 3px"
              pill
            >
              <b-icon icon="info"></b-icon>
            </b-button>
            <b-button
              v-if="row.item.transaction_id != null"
              @click="RefundBack(row.item)"
              variant="primary"
              size="sm"
              style="padding: 3px; margin-right:5px"
              pill
            >
              <i class="icon-nm la la-reply"></i>
            </b-button>
          </template>
        </b-table>
        <b-button-group v-if="page_count > 1">
          <b-button @click="LoadData(1)"
            ><i class="flaticon2-next"></i
          ></b-button>
          <b-button
            v-for="page in pages"
            v-bind:key="page"
            @click="LoadData(page)"
            :variant="page == current_page ? 'success' : 'default'"
            >{{ page }}</b-button
          >
          <b-button @click="LoadData(page_count)"
            ><i class="flaticon2-back"></i
          ></b-button>
        </b-button-group>
      </div>
    </b-card>
    <b-modal
      id="refundback-modal"
      style="justify-content: space-around"
      title="استرداد وجه"
      hide-footer
    >
      <b-alert :show="error.length > 0" variant="danger">
        <p v-for="er in error" v-bind:key="er">{{ er }}</p>
      </b-alert>
      <b-form>
        <b-row>
          <b-col>
            <b-form-group label="مبلغ:" label-for="refund_price">
              <b-input-group>
                <b-input
                  class="text-right ltr"
                  id="refund_price"
                  v-model="refund_data.amount"
                  required
                ></b-input>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label="مبلغ کل:" label-for="total_price">
              <b-input-group>
                <b-input
                  :disabled="disabled"
                  class="text-right ltr"
                  id="total_price"
                  v-model="refund_data.total_price"
                  required
                ></b-input>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col>
            <b-button
              style="width: 100%"
              variant="danger"
              @click="hideRefundBackModal"
              >بازگشت</b-button
            >
          </b-col>
          <b-col>
            <b-button
              style="width: 100%"
              variant="primary"
              id="btnSave"
              :class="loading ? 'spinner spinner-light spinner-right' : ''"
              @click="sendRequest"
              >استرداد</b-button
            >
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
  </div>
</template>
<style>
.rtl {
  direction: rtl;
}
.ltr {
  direction: ltr;
}
</style>
<script>
import httpHelper from "../../helpers/httpHelper";
import persianDate from "../../helpers/persianDate";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
export default {
  name: "gardesh",
  data() {
    return {
      disabled: true,
      refund_data: {
        amount: 0,
        total_price: 0,
        transaction_id: 0,
      },
      loading: false,
      dataLoaded: false,
      pages: [],
      current_page: 0,
      page_count: 0,
      merchants: [],
      error: [],
      fields: [
        {
          label: "کد تراکنش",
          key: "transaction_id",
          formatter: (value, key, item) => {
            return value == null ? item.doc_id : value;
          },
        },
        {
          label: "عنوان تراکنش",
          key: "des",
          formatter: (value, key, item) => {
            return item.doc_id <= 0
              ? "تراکنش ناموفق"
              : item.ttalWithoutKarmozd >= 0
              ? "واریز"
              : "برداشت";
          },
        },
        {
          label: "تاریخ",
          key: "created_at",
          formatter: (value, key, item) => {
            var d = new Date(value);
            return (
              persianDate.getDateByFormat(value) +
              " " +
              d.getHours() +
              ":" +
              d.getMinutes()
            );
          },
        },
        {
          label: "مبلغ با احتساب کارمزد",
          key: "ttalWithoutKarmozd",
          formatter: (value, key, item) => {
            ///var mezrab = item.bes - item.bed > 0 ? 1 : -1;
            //return Number(mezrab * (item.bes - item.bed)).toLocaleString();
            return Number(value).toLocaleString();
          },
          tdClass: (value, key, item) => {
            return item.doc_id <= 0
              ? "text-warning"
              : item.ttalWithoutKarmozd > 0
              ? "text-success"
              : "text-danger";
          },
        },
        {
          label: "کارمزد",
          key: "karmozd",
          formatter: (value, key, item) => {
            return Number(value).toLocaleString();
          },
        },
        {
          label: "موجودی",
          key: "Total",
          formatter: (value, key, item) => {
            return item.doc_id <= 0 ? "-----" : Number(value).toLocaleString();
          },
        },
        {
          label: "جزییات",
          key: "details",
        },
      ],
      datas: [],
      trDetail: {
        location: { countryCode: "ir" },
      },
      DateFrom: "",
      DateTo: "",
      CardNumber: "",
      SaleOrderId: "",
      api: null,
      justsuccess: "not_accepted",
      vmType: 1,
      vmOptions: [
        { text: "همه ی تراکنش ها", value: "1" },
        { text: "فقط واریز", value: "2" },
        { text: "فقط برداشت", value: "3" },
      ],
    };
  },
  methods: {
    hideRefundBackModal() {
      this.$bvModal.hide("refundback-modal");
    },
    ShowDetail(id) {
      var url = "transactions?id=" + id;
      httpHelper.getData(url).then((res) => {
        this.trDetail = res.result;
        this.$bvModal.show("transaction-details");
      });
    },
    RefundBack(item) {
      this.error = [];
      this.refund_data.amount = item.ttalWithoutKarmozd;
      this.refund_data.total_price = item.ttalWithoutKarmozd;
      this.refund_data.transaction_id = item.transaction_id;
      this.$bvModal.show("refundback-modal");
    },
    sendRequest() {
      this.error = [];
      if (this.refund_data.amount > this.refund_data.total_price) {
        this.error.push("مبلغ درخواستی نباید از مبلغ کل بیشتر گردد");
        return;
      }
      httpHelper
        .postData("refundtransaction", this.refund_data)
        .then((response) => {
          this.loading = false;
          if (response.success == true) {
            this.LoadData(1);
            this.$bvModal.hide("refundback-modal");
          } else {
            this.error = [];
            for (var key in response.error) {
              response.error[key].forEach((element) => {
                this.error.push(element);
              });
            }
          }
        })
        .catch((res) => {
        });
    },
    createPager(last_page, current_page) {
      this.pages = [];
      this.current_page = current_page;
      var startPageer = this.current_page > 5 ? this.current_page - 4 : 0;
      var endPageer = last_page > 5 ? this.current_page + 3 : last_page;
      this.page_count = last_page;
      if (this.current_page + 3 > this.page_count) {
        endPageer = this.page_count;
      }
      for (let i = startPageer; i < endPageer; i++) {
        this.pages.push(i + 1);
      }
    },
    LoadData(page) {
      const submitButton = this.$refs["filter_btn"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");
      this.datas = [];
      var query = "";
      query += "&cardnumber=" + this.CardNumber;
      query += "&vmtype=" + this.vmType;
      query += "&saleorderid=" + this.SaleOrderId;
      query += "&datefrom=" + this.DateFrom;
      query += "&dateto=" + this.DateTo;
      if (this.justsuccess != "not_accepted") {
        query += "&justsuccess=1";
      }
      if (this.api != null) {
        query += "&api=" + this.api;
      }
      this.dataLoaded = false;
      httpHelper.getData("GardeshHesab?page=" + page + query).then((res) => {
        this.dataLoaded = true;
        this.datas = res.result.data;
        this.createPager(res.result.last_page, res.result.current_page);
        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
      });
      httpHelper.getData("paymentgateways").then((res) => {
        this.merchants = res.result
          .filter((t) => {
            return t.mdid12_money_type == 483 || t.mdid12_money_type == 484;
          })
          .map((t) => {
            return {
              text: t.website_name,
              value: t.id,
            };
          });
      });
    },
    LoadDataExcel(page) {
      var query = "";
      query += "&cardnumber=" + this.CardNumber;
      query += "&vmtype=" + this.vmType;
      query += "&saleorderid=" + this.SaleOrderId;
      query += "&datefrom=" + this.DateFrom;
      query += "&dateto=" + this.DateTo;
      if (this.justsuccess != "not_accepted") {
        query += "&justsuccess=1";
      }
      if (this.api != null) {
        query += "&api=" + this.api;
      }
      httpHelper.getData("GardeshHesab?excel=1" + query).then((res) => {
        if (res.success) {
          const anchor = document.createElement("a");
          const filename = "gardesh.xlsx";
          anchor.setAttribute("download", filename);
          anchor.setAttribute("href", res.result);
          document.body.appendChild(anchor);
          anchor.click();
          document.body.removeChild(anchor);
        }
      });
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "تراکنش ها" }]);
    this.LoadData(1);
  },
};
</script>
